export default __webpack_public_path__ + "static/banner-8bb9b740af6b7be024eece3396095c18.png";